import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { UserPreferencesActions } from '@osos/shared/legacy-core';

@Component({
  selector: 'app-exit-delegation-button',
  templateUrl: './exit-delegation-button.component.html',
  styleUrls: ['./exit-delegation-button.component.scss'],
  imports: [TranslateModule],
})
export class ExitDelegationButtonComponent {
  constructor(private store: Store) {}

  cancelDelegation($event: MouseEvent) {
    this.store.dispatch(new UserPreferencesActions.SetActiveDelegation(null));
    $event.preventDefault();
    $event.stopPropagation();
  }
}
